<template>
  <div>
    <CRow>
      <CCol md="12">
        <span class="float-right"><img src="main_logo.png" class="home-logo"></span>
        <h1 class="home-title"><b>KPI BONUS</b></h1>
        <br />
        <h1 class="home-greeting">¡Hola {{user_name.split(' ')[0]}}!</h1>
        <br />
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <br />
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12" class="text-center">
        <CButton @click="changeTab('challenges')" :color="tab == 'challenges' ? 'info' : 'default'" size="sm" class="m-1 home-tab-button">Concursos y Retos</CButton>
        <CButton @click="changeTab('awards')" :color="tab == 'awards' || tab == 'points' || tab == 'shops' ? 'info' : 'default'" size="sm" class="m-1 home-tab-button">Recompensas</CButton>
        <CButton @click="changeTab('account')" :color="tab == 'account' ? 'info' : 'default'" size="sm" class="m-1 home-tab-button">Mi cuenta</CButton>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <br />
      </CCol>
    </CRow>
    <ChallengesList v-if="tab == 'challenges'" :challenges="challenges" />
    <CRow v-if="tab == 'awards'">
      <CCol md="12" class="home-section-col">
        <RewardsSummary
          :points="points"
          @change-points="changePointsTab"
          @change-shop="changeShopTab"
        />
        <RedeemedAwardsHistory :items="award_exchanges" />
      </CCol>
    </CRow>
    <CRow v-if="tab == 'account'">
      <CCol md="12" class="home-section-col">
        <SupplierAccountCard
          :user="user"
          :owner="owner"
          :type="type"
          @edit-user="userModal"
          @edit-contact="contactModal"
          @confirm-wallet="confirmWallet"
        />
      </CCol>
    </CRow>
    <CRow v-if="tab == 'points'">
      <CCol md="12" class="home-section-col">
        <PointsTickets
          :points-type="points_type"
          :point-tickets="point_tickets"
          @back="changeTab('awards')"
        />
      </CCol>
    </CRow>
    <CRow v-if="tab == 'shops'">
      <CCol md="12" class="home-section-col">
        <RewardsShop
          :points="points"
          :shop-type="shop_type"
          :point-products="point_products"
          @select-product="getProduct"
        />
      </CCol>
    </CRow>

    <AwardBuyModal ref="awardBuyModal" @bought="boughtProcess"></AwardBuyModal>
    <SupplierPasswordModal ref="passwordModal" :user="user" @update="updatePassword"></SupplierPasswordModal>
    <SupplierContactModal ref="contactModal" :user="user" @update="updateContact"></SupplierContactModal>
  </div>
</template>
<script>

import store from '../../../store'
import challenges_ws from '../../../services/challenges';
import account_ws from '../../../services/account';
import users_ws from '../../../services/users';
import suppliers_ws from '../../../services/suppliers';
import managers_ws from '../../../services/managers';
import executives_ws from '../../../services/executives';

import RewardsSummary from '../../../components/suppliersHome/RewardsSummary.vue'
import RedeemedAwardsHistory from '../../../components/suppliersHome/RedeemedAwardsHistory.vue'
import PointsTickets from '../../../components/suppliersHome/PointsTickets.vue'
import RewardsShop from '../../../components/suppliersHome/RewardsShop.vue'
import SupplierAccountCard from '../../../components/suppliersHome/SupplierAccountCard.vue'
import ChallengesList from '../../../components/suppliersHome/ChallengesList.vue'

import AwardBuyModal from './AwardBuyModal.vue'
import SupplierContactModal from './modals/SupplierContactModal.vue'
import SupplierPasswordModal from './modals/SupplierPasswordModal.vue'


export default {
  name: 'SuppliersHome',
  components: {
    RewardsSummary,
    RedeemedAwardsHistory,
    PointsTickets,
    RewardsShop,
    SupplierAccountCard,
    ChallengesList,
    AwardBuyModal,
    SupplierContactModal,
    SupplierPasswordModal
  },
  data () {
    return {
      tab: 'challenges',
      points_type: 'event',
      shop_type: 'event',
      user: null,
      owner: null,
      type: 'supplier',
      name: '',
      user_name: '',
      points: {},
      point_tickets: [],
      point_products: [],
      award_exchanges: [],
      challenges: []
    }
  },
  mounted: async function() {
    let response = await account_ws.getInfo(); 

    if (response.type !== 'success' || !response.data || !response.data.user) {
      this.showToast(response.type || 'error', response.message || 'No fue posible cargar la cuenta');
      return;
    }

    this.name = response.data.name;
    this.user_name = response.data.user.first_name || '';
    this.user = response.data.user;

    if (this.user && this.user.manager) {
      this.type = "manager";
      this.owner = this.user.manager;
    }
    else if (this.user && this.user.executive) {
      this.type = "executive";
      this.owner = this.user.executive;
    }
    else if (this.user && this.user.supplier) {
      this.type = "supplier";
      this.owner = this.user.supplier;
    }
    else {
      this.owner = null;
    }

    let response3;
    if (this.user.role == "manager") {
      response3 = await managers_ws.getRedeemablePointsApprovedByManager();
    } else if (this.user.role == "executive") {
      response3 = await executives_ws.getPoints();
    } else {
      response3 = await account_ws.getPoints();
    }

    if(response3.type == "success"){
      this.points = response3.data;
    }

    let response4 = await challenges_ws.getActives(); 

    if(response4.type == "success"){
      this.challenges = response4.data;
    }

    await this.loadAwardExchangesHistory();
  },
  methods: {
    getRewardsScope () {
      // Prioriza el owner detectado en account/info para evitar desalineaciones de slug de rol.
      if (this.type === 'executive') return 'executive';
      if (this.type === 'manager') return 'manager';

      if (this.user && this.user.role === 'executive') return 'executive';
      if (this.user && this.user.role === 'manager') return 'manager';

      return 'supplier';
    },
    async loadAwardExchangesHistory () {
      const scope = this.getRewardsScope();
      let response;
      if (scope === "manager") {
        response = await managers_ws.getAwardExchangesHistory();
      } else if (scope === "executive") {
        response = await executives_ws.getAwardExchangesHistory();
      } else {
        response = await suppliers_ws.getAwardExchangesHistory();
      }

      if(response.type == "success"){
        this.award_exchanges = response.data;
      }
    },
    changeTab (tab) {
      this.tab = tab;
    },
    async changePointsTab (type) {
      this.loading();
      const scope = this.getRewardsScope();

      this.point_tickets = [];
      
      this.tab = "points";
      this.points_type = type;

      let response;
      if (scope === "manager") {
        response = await managers_ws.getPointTickets(type);
      } else if (scope === "executive") {
        response = await executives_ws.getPointTickets(type);
      } else {
        response = await suppliers_ws.getPointTickets(type);
      }

      if(response.type == "success"){
        this.point_tickets = response.data;

        this.loaded();
      }
    },
    async confirmWallet () {
      this.loading();

      if (!this.owner || !this.owner.id) {
        this.showToast('error', 'No fue posible validar la cuenta para confirmar monedero');
        this.loaded();
        return;
      }
      
      let filters = {
        type: this.type,
        owner_id: this.owner.id,
      }

      let response = await suppliers_ws.confirmWallet(filters); 

      if(response.type == "success"){
        window.location.reload();
        this.loaded();
      }
    },
    async changeShopTab (type) {
      this.tab = "shops";
      this.shop_type = type;
      const scope = this.getRewardsScope();

      let response;
      if (scope === "manager") {
        response = await managers_ws.getPointProducts(type);
      } else if (scope === "executive") {
        response = await executives_ws.getPointProducts(type);
      } else {
        response = await suppliers_ws.getPointProducts(type);
      }

      if(response.type == "success"){
        this.point_products = response.data;

        this.loaded();
      }
    },
    getProduct (product) {
      const availablePoints = Number(this.points[product.type] || 0);
      this.$refs.awardBuyModal.storeModal(product, availablePoints);
    },
    async boughtProcess (data) {
      const scope = this.getRewardsScope();
      let response;
      if (scope === "manager") {
        response = await managers_ws.boughtAward(data);
      } else if (scope === "executive") {
        response = await executives_ws.boughtAward(data);
      } else {
        response = await suppliers_ws.boughtAward(data);
      }
      
      if(response.type == "success"){
        let response2;
        if (scope === "manager") {
          response2 = await managers_ws.getRedeemablePointsApprovedByManager();
        } else if (scope === "executive") {
          response2 = await executives_ws.getPoints();
        } else {
          response2 = await account_ws.getPoints();
        }
        if(response2.type == "success"){
          this.points = response2.data;
        }

        await this.loadAwardExchangesHistory();

        let response3;
        if (scope === "manager") {
          response3 = await managers_ws.getPointProducts(data.type.replaceAll("_points",""));
        } else if (scope === "executive") {
          response3 = await executives_ws.getPointProducts(data.type.replaceAll("_points",""));
        } else {
          response3 = await suppliers_ws.getPointProducts(data.type.replaceAll("_points",""));
        }

        if(response3.type == "success"){
          this.point_products = response3.data;

          this.loaded();
        }
      }

      this.showToast(response.type, response.message);
    },
    contactModal () {
      this.$refs.contactModal.updateModal(this.user);
    },
    async updateContact (data) {
      this.loading();
      let response = await users_ws.update(data);

      if(response.type == "success"){
        this.user = response.data;
      }
      
      this.showToast(response.type, response.message);
      this.loaded();
    },
    userModal () {
      this.$refs.passwordModal.updateModal(this.user);
    },
    async updatePassword (data) {
      this.loading();
      let response = await users_ws.updatePassword(data);

      if(response.type == "success"){
        this.user = response.data;
      }
      
      this.showToast(response.type, response.message);
      this.loaded();
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style scoped>
.home-logo {
  width: 100px;
  border-radius: 10px;
}

.home-title {
  font-size: 1.6rem;
}

.home-greeting {
  font-size: 1rem;
}

.home-tab-button {
  font-size: 12px;
}

.home-section-col {
  font-size: 12px;
}
</style>
